import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentAbandonApplicationData,
  type EnrollmentAbandonApplicationSubmitOutput,
} from '../../../models/enrollment/generic/abandon-application'

export const getEnrollmentAbandonApplicationDataMock: EnrollmentAbandonApplicationData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/abandon-application',
}

export const submitEnrollmentAbandonApplicationDataMock: EnrollmentAbandonApplicationSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/personal-info',
}

export const mockGetEnrollmentAbandonApplicationData = graphql.mutation('getEnrollmentAbandonApplicationData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentAbandonApplicationDataMock } })
})

export const mockSubmitEnrollmentAbandonApplicationData = graphql.mutation(
  'submitEnrollmentAbandonApplicationData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentAbandonApplicationDataMock } })
  },
)

export const mockEnrollmentAbandonApplication = [
  mockGetEnrollmentAbandonApplicationData,
  mockSubmitEnrollmentAbandonApplicationData,
]
